import {Component, EventEmitter, Input, OnChanges, OnDestroy, OnInit, Output, SimpleChanges} from '@angular/core';
import {UntypedFormBuilder, UntypedFormGroup} from '@angular/forms';
import {Individu} from '@Common/core/services';
import {Dossiers} from 'app/dar/common/services';
import {CommentTypeEnum} from 'app/dar/common/services/enums/commentTypeEnum';
import {CommentsModel} from 'app/dar/common/services/comments/comments.model';
import {CommentsService} from 'app/dar/common/services/comments/comments.service';
import {SubSink} from '@Common/core/utils/subsink';

@Component({
  selector: 'app-comment-edit',
  templateUrl: './edit.component.html',
  styleUrls: ['./edit.component.scss']
})
export class EditComponent implements OnInit, OnChanges, OnDestroy {
  commentFormGroup: UntypedFormGroup;
  commentTypeEnum = CommentTypeEnum;
  commentSent = false;
  @Input() dossier: Dossiers;
  @Input() commentator: Individu;
  @Input() isGestionnaire: boolean;
  @Input() comment: CommentsModel;
  @Output() closeCts = new EventEmitter<CommentsModel>();
  subSink = new SubSink();
  comment_obj = <CommentsModel>{
    id: 0,
  };
  constructor(private formBuilder: UntypedFormBuilder, private commentSvc: CommentsService) { }

  ngOnInit(): void {
    this._initCommentFormGroup();
  }

  private _initCommentFormGroup(): void {
    this.commentFormGroup = this.formBuilder.group({
      id: [0],
      content: [''],
      type: [this.commentTypeEnum.public],
      commentator: [this.commentator.uid],
      dossier: [this.dossier.id],
    });
  }

  private _initCommentObj(): void {
    this.comment_obj = <CommentsModel>{
      id: 0,
    };
  }

  sendComment(): void {
    this.commentSent = true;
    this._setCommentObj();
    if (this.comment_obj.id > 0) {
      this.subSink.sink = this.commentSvc.update(this.comment_obj).subscribe(
        _data => {
          this._initCommentFormGroup();
          this._initCommentObj();
          this.closeCts.emit(_data);
          this.commentSent = false;
        }
      );
    } else {
      this.subSink.sink = this.commentSvc.create(this.comment_obj).subscribe(
        _data => {
          this._initCommentFormGroup();
          this._initCommentObj();
          this.closeCts.emit(_data);
          this.commentSent = false;
        }
      );
    }
  }


  clearComment(): void {
    this._initCommentFormGroup();
    if (this.comment.id > 0) {
      this._setCommentForm();
    }
  }

  private _setCommentObj(): void {
    this.comment_obj.commentator = this.commentFormGroup.get('commentator').value;
    this.comment_obj.type = this.commentFormGroup.get('type').value;
    this.comment_obj.content = this.commentFormGroup.get('content').value;
    this.comment_obj.dossier = this.commentFormGroup.get('dossier').value;
  }

  private _setCommentForm(): void {
    this.commentFormGroup.patchValue({id: this.comment_obj.id});
    this.commentFormGroup.patchValue({content: this.comment_obj.content});
    this.commentFormGroup.patchValue({commentator: this.comment_obj.commentator});
    this.commentFormGroup.patchValue({dossier: this.comment_obj.dossier});
    this.commentFormGroup.patchValue({type: this.comment_obj.type});
  }

  ngOnChanges(changes: SimpleChanges): void {
    this._initCommentFormGroup();
    this._initCommentObj();
    if (changes?.comment?.currentValue && changes?.comment?.currentValue['id'] > 0) {
      this.comment_obj = this.comment;
      this._setCommentForm();
    }
  }
  ngOnDestroy(): void {}
}
